<div class="container">
    <div class="wrapper">
        <div *ngIf="!isExtension" class="logo-wrapper">
            <app-logo></app-logo>
        </div>
        <div class="inner" *ngIf="!showForgotPassword">
            <app-user-tabs [activatedType]="this.activeOauthType" *ngIf="!showRegistration"></app-user-tabs>
            <h2 *ngIf="!showRegistration" class="header">{{ 'Auth.header' | translate }}</h2>
            <ng-container *ngIf="!showRegistration">
                <ng-container *ngIf="this.activeOauthType === OauthType.SIGNIN">
                    <app-signin-form (onSubmit)="onLogin($event)"></app-signin-form>
                </ng-container>
                <ng-container *ngIf="this.activeOauthType === OauthType.SIGNUP">
                    <app-signup-form (onSubmit)="onSignup($event)"></app-signup-form>
                </ng-container>
            </ng-container>
            <app-registration-form *ngIf="showRegistration && signupData && signupData.email" [email]="signupData.email"
                (onSubmit)="onVerifyEmail($event)" (onResend)="onResend()"
                (modeChange)="navigateToLogin()"></app-registration-form>
        </div>
        <div class="inner" *ngIf="showForgotPassword">
            <app-forgot-password style="width: 100%;" (onSendCode)="onSendResetCode($event)" [isCodeSent]="isCodeSent"
                (onSubmit)="onResetPassword($event)" (modeChange)="navigateToLogin()">
            </app-forgot-password>
        </div>
    </div>
</div>